import React, { useEffect, useState } from "react";
import styles from "./school-subjects.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import {
  deleteSubject,
  fetchSubjectList,
} from "../../../../../../../services/subject";
import {
  cardColorArr,
  DEFAULT_IMAGE,
} from "../../../../../../../constants/common";
import CustomTag from "../../../../../../../common/custom-tag/custom-tag";
import CustomPopover from "../../../../../../../common/custom-popover/custom-popover";
import AddEditSchoolSubjects from "./components/add-edit-school-subjects/add-edit-school-subjects";
import { refetchSchool } from "../../../../../../../utils/common";
import { toast } from "react-toastify";

const SchoolSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getSubjects();
  }, []);

  const getSubjects = async (tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchSubjectList(payload);
      if (response?.data) {
        const data = response?.data?.data?.subjects;
        setSubjects(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getSubjects(page, pageSize);
  };

  const handleEditSubject = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getSubjects();
    setOpenDrawer(false);
  };

  const handleDeleteSubject = async (id) => {
    try {
      await deleteSubject(id);
      getSubjects();
      refetchSchool();
      toast.success("Subject deleted Successfully");
    } catch (err) {
      toast.error(err.data.message);
      console.log(err);
    }
  };

  const handleAddSubjects = () => {
    setEditDetails(null);
    setOpenDrawer(true);
  };

  const columns = [
    {
      title: "Logo",
      dataIndex: "image_url",
      key: "image_url",
      width: "5%",
      render: (value) => (
        <img
          src={value ? value : DEFAULT_IMAGE}
          height={30}
          width={30}
          alt="subject"
          style={{ borderRadius: 6 }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DEFAULT_IMAGE;
          }}
        />
      ),
    },
    {
      title: "Subjects",
      dataIndex: "name",
      key: "name",
      render: (value) => value || "-",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: (a, b) => a?.department?.name.localeCompare(b?.department?.name),
      render: (value) => {
        const randomIndex = Math.floor(Math.random() * cardColorArr.length);
        const colorStyle = cardColorArr[randomIndex];
        const colour_code = value?.colour_code;
        return (
          <CustomTag
            text={value?.name}
            color={colour_code ? colour_code : colorStyle?.color}
            background={
              colour_code ? `${colour_code}1A` : colorStyle?.background
            }
            borderColor={colour_code ? `${colour_code}66` : colorStyle?.border}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditSubject(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this subject?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteSubject(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>Subjects</Typography>
        <CustomButton
          title="Add New Subject"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleAddSubjects}
        />
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={subjects}
          loading={loading}
          headerColor="#667085"
          headerBackgroundColor="#F9FAFB"
          total={totalCount}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>
      <AddEditSchoolSubjects
        open={openDrawer}
        onClose={handleOnClose}
        data={editDetails}
      />
    </div>
  );
};

export default SchoolSubjects;
